import { FormBuilderState, FormBuilderType, FormBuilderValidator, validatorFunc } from "@grassrootly/rn-core";

export interface ResetPasswordProps {
  authParams: {
    access_token: string;
    expires_at: number;
    expired_in: number;
    refresh_token: string;
    token_type: string;
    type: string;
  };
  title: string;
  body: string;
}

export type ResetPasswordFormType = { newPassword: string; repeatNewPassword: string };

function validateRepeatPassword<T extends FormBuilderState<ResetPasswordFormType>>(
  value: string,
  field: string,
  state?: T
) {
  if (value && state?.newPassword?.value && value !== state?.newPassword?.value) {
    return {
      valid: false,
      error: "Repeat Password must me equal to New Password",
    };
  }
  return {
    valid: true,
  };
}

export const resetPasswordForm: FormBuilderType<ResetPasswordFormType> = {
  newPassword: {
    type: "password",
    name: "new-password",
    label: "New Password",
    defaultValue: "",
    validators: [FormBuilderValidator.required(), FormBuilderValidator.password()],
    required: true,
    props: {
      keyboardType: "visible-password",
    },
  },
  repeatNewPassword: {
    type: "password",
    name: "repeat-password",
    label: "Repeat Password",
    defaultValue: "",
    validators: [FormBuilderValidator.required(), FormBuilderValidator.custom(validateRepeatPassword as validatorFunc)],
    required: true,
    props: {
      keyboardType: "visible-password",
    },
  },
};
